/**
 *
 * Asynchronously loads the component for Iku003
 * Author: July
 */

import loadable from 'utils/loadable';

export default loadable(() => import('./index'));
